var map = {
	"./BeforeAfter.js": 1537,
	"./CodeBlock.js": 1742,
	"./CodeCard.js": 7151,
	"./Demo.js": 8197,
	"./Diagram.js": 6719,
	"./PromptMarquee.js": 3612,
	"./Starfield.js": 6698,
	"components/BeforeAfter.js": 1537,
	"components/CodeBlock.js": 1742,
	"components/CodeCard.js": 7151,
	"components/Demo.js": 8197,
	"components/Diagram.js": 6719,
	"components/PromptMarquee.js": 3612,
	"components/Starfield.js": 6698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8965;